import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/lib/assets";

const links = [
  { href: "#features", label: "Producto" },
  { href: "#verticals", label: "Por vertical" },
  { href: "#how", label: "Cómo funciona" },
  { href: "#pricing", label: "Precio" },
  { href: "#faq", label: "Preguntas" },
];

export default function Navbar({ onDemoClick }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="landing-navbar"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F2EDE3]/85 backdrop-blur-xl border-b border-[#111111]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-8xl mx-auto px-5 sm:px-8 py-4 flex justify-between gap-4">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex gap-2.5 group shrink-0 min-w-0"
        >
          <img
            src={BRAND.logo}
            alt=""
            className="h-8 w-8 shrink-0 rounded-md object-contain"
            width={32}
            height={32}
            decoding="async"
          />
          <span className="font-['Cabinet_Grotesk'] font-black text-[24px] tracking-tight text-[#111111]">
            Kubo <span className="text-[#a68a6d]">Payments</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8 xl:gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-base font-medium text-[#111111]/85 hover:text-[#a68a6d] transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3 shrink-0">
          <a
            href="http://app.kubopayments.com/register"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-register"
            className="hidden sm:inline-flex items-center gap-1.5 bg-[#111111] hover:bg-[#2a2a2a] text-white text-base font-bold px-6 py-3 rounded-full transition-all hover:scale-105 shadow-[0_8px_20px_rgba(17,17,17,0.2)]"
          >
            Registro gratuito
            <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
          </a>
          <button
            onClick={onDemoClick}
            data-testid="nav-cta"
            className="hidden sm:inline-flex items-center gap-1.5 bg-[#a68a6d] hover:bg-[#8f7659] text-white text-base font-bold px-6 py-3 rounded-full transition-all hover:scale-105 shadow-[0_8px_20px_rgba(166,138,109,0.25)]"
          >
            Agendar demo
            <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
          </button>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 -mr-2 text-[#111111]"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          className="lg:hidden bg-[#F2EDE3] border-t border-[#111111]/10 overflow-hidden"
        >
          <div className="flex flex-col p-5 gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-lg font-medium text-[#111111] py-1.5"
              >
                {l.label}
              </a>
            ))}
            <a
              href="http://app.kubopayments.com/register"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center justify-center bg-[#111111] text-white text-sm font-bold px-5 py-3 rounded-full"
            >
              Registro gratuito
            </a>
            <button
              onClick={() => { setOpen(false); onDemoClick(); }}
              className="mt-2 inline-flex items-center justify-center bg-[#a68a6d] text-white text-sm font-bold px-5 py-3 rounded-full"
            >
              Agendar demo
            </button>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
}
